/**
 * Carousels.
 * */

import Flickity from 'flickity';

Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
}
Flickity.createMethods.push('_createResizeClass');
var resize = Flickity.prototype.resize;

Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call( this );
  this.element.classList.add('flickity-resize');
}

export default {
  init() {

    $( window ).load( function() {
      if($('.carousel').length) {
        new Flickity( '.carousel', {
          // options, defaults listed
          prevNextButtons: false,
          // creates and enables buttons to click to previous & next cells
          pageDots: false,
          // create and enable page dots
          wrapAround: true,
          // at end of cells, wraps-around to first for infinite scrolling
          autoPlay: 1500,
        });
      }

      setTimeout(function() {
        if($('.carousel-testimonials').length) {
          new Flickity( '.carousel-testimonials', {
            // options, defaults listed
            prevNextButtons: false,
            // creates and enables buttons to click to previous & next cells
            pageDots: true,
            // create and enable page dots
            wrapAround: true,
            // at end of cells, wraps-around to first for infinite scrolling
            autoPlay: false,
            adaptiveHeight: true,
          });
        }

        if($('.carousel-testimonials-alt').length) {
          new Flickity( '.carousel-testimonials-alt', {
            // options, defaults listed
            prevNextButtons: false,
            // creates and enables buttons to click to previous & next cells
            pageDots: true,
            // create and enable page dots
            wrapAround: false,
            // at end of cells, wraps-around to first for infinite scrolling
            autoPlay: false,
            groupCells: true,
            adaptiveHeight: true,
          });
        }
      }, 1000);

    });

    if($('.badges-carousel').length) {
      new Flickity( '.badges-carousel', {
        // options, defaults listed
        prevNextButtons: false,
        // creates and enables buttons to click to previous & next cells
        pageDots: true,
        // create and enable page dots
        wrapAround: true,
        // at end of cells, wraps-around to first for infinite scrolling
        autoPlay: 1500,
      });
    }

    if($('.product-range__cards--mobile').length) {
      new Flickity( '.product-range__cards--mobile', {
        // options, defaults listed
        prevNextButtons: false,
        // creates and enables buttons to click to previous & next cells
        pageDots: true,
        // at end of cells, wraps-around to first for infinite scrolling

      });
    }
    if($('.custom-card--carousel').length) {
      new Flickity( '.custom-card--carousel', {
        prevNextButtons: false,
        // creates and enables buttons to click to previous & next cells
        pageDots: true,
        // create and enable page dots
        wrapAround: true,
        // at end of cells, wraps-around to first for infinite scrolling

      });
    }

  },


}





// WEBPACK FOOTER //
// ./scripts/lib/carousels.js